var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"mb_banquan"},[_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm.$t('footer.copyrightMb')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb_footer"},[_c('div',{staticClass:"footerItem"},[_c('img',{attrs:{"src":require("@/assets/images/0_icon_ema.png"),"alt":""}}),_vm._v(" info@seikaiyaku.com ")])])
}]

export { render, staticRenderFns }